/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_LEGAL_LOCALE_DOCS_DETAILS_REQUEST = "FETCH_LEGAL_LOCALE_DOCS_DETAILS_REQUEST";
export const FETCH_LEGAL_LOCALE_DOCS_DETAILS_SUCCESS = "FETCH_LEGAL_LOCALE_DOCS_DETAILS_SUCCESS";
export const FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE = "FETCH_LEGAL_LOCALE_DOCS_DETAILS_FAILURE";
export const FETCH_LEGAL_DOCUMENT_INFOS_REQUEST = "FETCH_LEGAL_DOCUMENT_INFOS_REQUEST";
export const FETCH_LEGAL_DOCUMENT_INFOS_SUCCESS = "FETCH_LEGAL_DOCUMENT_INFOS_SUCCESS";
export const FETCH_LEGAL_DOCUMENT_INFOS_FAILURE = "FETCH_LEGAL_DOCUMENT_INFOS_FAILURE";
export const UPDATE_LEGAL_DOCUMENT_INFO_REQUEST = "UPDATE_LEGAL_DOCUMENT_INFO_REQUEST";
export const UPDATE_LEGAL_DOCUMENT_INFO_SUCCESS = "UPDATE_LEGAL_DOCUMENT_INFO_SUCCESS";
export const UPDATE_LEGAL_DOCUMENT_INFO_FAILURE = "UPDATE_LEGAL_DOCUMENT_INFO_FAILURE";
export const FETCH_OEM_LEGAL_INFO_REQUEST = "FETCH_OEM_LEGAL_INFO_REQUEST";
export const FETCH_OEM_LEGAL_INFO_SUCCESS = "FETCH_OEM_LEGAL_INFO_SUCCESS";
export const FETCH_OEM_LEGAL_INFO_FAILURE = "FETCH_OEM_LEGAL_INFO_FAILURE";